import { type IconName } from '@/app/elements/svg/loader';
import { BRAND } from '@/utils/constants';

const CSS_LABEL_ICON_MAP: Record<string, IconName | null> = {
    'hot-right-now': 'social-tag',
    'exclusive-shield': 'fanduel-shield',
    exclusive: process.env.BRAND === BRAND.FANDUEL ? 'fanduel-shield' : null
};

export const getTextBadgeDisplayText = (
    cssLabel: string,
    label: string,
    hasShield: boolean,
    playerCount?: number
): string => {
    if (hasShield) {
        return 'Exclusive';
    }

    if (cssLabel === 'hot-right-now') {
        return playerCount?.toString() ?? label;
    }

    return label;
};

export const resolveTextBadge = (cssLabel: string, label: string, playerCount?: number) => {
    const iconName = CSS_LABEL_ICON_MAP[cssLabel];
    const hasShield = iconName === 'fanduel-shield';

    return {
        iconName,
        badgeCssClass: hasShield ? 'exclusive' : cssLabel,
        displayText: getTextBadgeDisplayText(cssLabel, label, hasShield, playerCount),
        iconClassName: hasShield ? 'shield-icon' : 'badge-icon',
        isEarlyAccess: cssLabel === 'early-access'
    };
};
